import { cloneDeep } from 'lodash';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { ContractProvider } from '../providers/contract.provider';
import { ProductProvider } from '../providers/product.provider';
import { IdInterface, SelectedProductInterface } from '../data';
import { Transaction } from '../transaction/transaction';
import { UseCaseWithParam } from './common/use.case.with.params';

export interface GetSelectedProductsUseCaseParams {
    clientCode?: IdInterface;
}

@Injectable()
export class GetSelectedProductsUseCase
    implements UseCaseWithParam<GetSelectedProductsUseCaseParams, Observable<Transaction<SelectedProductInterface[]>>>
{
    constructor(private contractProvider: ContractProvider, private productProvider: ProductProvider) {}

    bind(params: GetSelectedProductsUseCaseParams): Observable<Transaction<SelectedProductInterface[]>> {
        return this.contractProvider.current().pipe(
            switchMap((transaction) =>
                transaction.map(
                    (contract) =>
                        this.productProvider.findSelected(contract.encryptedCode, params.clientCode).pipe(
                            map((transactionProducts) =>
                                transactionProducts.map(
                                    (products) => Transaction.success(cloneDeep(products)),
                                    (throwable) => Transaction.error(throwable.message)
                                )
                            )
                        ),
                    (throwable) => of(Transaction.error<SelectedProductInterface[]>(throwable.message))
                )
            )
        );
    }
}
